import { css } from "@emotion/react";
import { Alert, AlertTitle, Button, Grid } from "@mui/material";
import { appColor, CustomMuiButton, FontColor } from "@unit/styles";
import localforage from "localforage";
import NextLink from "next/link";
import { useRouter } from "next/router";
import React from "react";
import { MdClose } from "react-icons/md";

import BasicIconButton from "@/components/common/button/BasicIconButton";
import { useGlobalDialog } from "@/custom-hooks/jotai/use-global-dialog";
import { editSnsAccountPath, INSTAGRAM_PRO_ACCOUNT_SETUP_PATH } from "@/global-state/influencer-app-path";

const SnsProRecommendationPane: React.FC = () => {
  const router = useRouter();
  const { updateDialogType, closeDialog } = useGlobalDialog();

  const handleClose = async () => {
    closeDialog();
    await localforage.setItem("lastSuggestProAt", new Date().getTime());
    await updateDialogType(3);
  };

  const handleGoToSNS = async () => {
    closeDialog();
    await localforage.setItem("lastSuggestProAt", new Date().getTime());
    await router.push(editSnsAccountPath);
  };

  return (
    <>
      <Grid item xs={12} p={2} css={style.container}>
        <div css={style.closeButton}>
          <BasicIconButton onClick={handleClose}>
            <MdClose color={FontColor.basic} />
          </BasicIconButton>
        </div>

        <Alert severity="info" css={style.dialogContent}>
          <AlertTitle>
            <strong css={style.title}>Instagramプロアカウント連携のお願い</strong>
          </AlertTitle>
          先日Instagram連携の仕様がアップデートされた影響で、一部のユーザー様の連携が解除されるケースが発生しています。未連携状態の方はお早めに再連携をお願いいたします。
          <br />
          なお連携するとインサイト情報の提供が自動化される事などから、プロアカウント連携者の採用率が高い傾向が続いております。まだ連携をしたことのない方はこの機会に連携することをオススメいたします。
          <br />
          <br />
          <NextLink css={style.linkText} href={INSTAGRAM_PRO_ACCOUNT_SETUP_PATH} passHref target={"_blank"}>
            ※プロアカウント連携の方法はこちら
          </NextLink>
        </Alert>
      </Grid>
      <Grid item xs={12} px={2} pb={2}>
        <Button
          css={CustomMuiButton}
          type="submit"
          fullWidth
          variant="contained"
          size={"large"}
          onClick={handleGoToSNS}
        >
          SNSアカウント登録ページへ
        </Button>
      </Grid>
    </>
  );
};
export default React.memo(SnsProRecommendationPane);

const style = {
  container: css`
    positing: relative;
  `,
  title: css`
    font-size: 15px;
  `,
  dialogContent: css`
    padding: 4px 12px;
    font-size: 13px;
    & .MuiAlert-icon {
      margin-right: 4px;
    }
  `,
  linkText: css`
    color: ${appColor.App.sidenav};
    font-weight: 700;
  `,
  closeButton: css`
    position: absolute;
    top: 4px;
    right: 4px;
  `,
};
